import { apiRequest } from './client'

export interface BillingStatus {
  plan: 'free' | 'pro' | 'team'
  stripeCustomerId: string | null
  stripeSubscriptionId: string | null
  planExpiresAt: string | null
}

export function getBillingStatus(): Promise<BillingStatus> {
  return apiRequest<BillingStatus>('/api/billing/status')
}

// 戻り先 URL はサーバー側で組み立てるため送らない
export function createCheckoutSession(): Promise<{ url: string }> {
  return apiRequest<{ url: string }>('/api/billing/checkout', { method: 'POST' })
}

export function createPortalSession(): Promise<{ url: string }> {
  return apiRequest<{ url: string }>('/api/billing/portal', { method: 'POST' })
}
